import type { ReactNode } from 'react'
import { useWindowDimensions } from 'react-native'
import ActionSheet from 'react-native-actions-sheet'

import { isWeb } from '@/constants/app'
import { WEB_VIEW_MAX_WIDTH } from '@/constants/config'

interface BottomSheetProps {
  children: ReactNode
  closeDrawer?: () => void
}

export function BottomSheet({ children, closeDrawer }: BottomSheetProps) {
  const { width: deviceWidth } = useWindowDimensions()
  return (
    <ActionSheet
      gestureEnabled={true}
      containerStyle={{
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        backgroundColor: '#fff',
        width: isWeb ? Math.min(WEB_VIEW_MAX_WIDTH, deviceWidth) : deviceWidth
      }}
      indicatorStyle={{
        marginBottom: 'auto',
        marginTop: 8,
        height: 4,
        width: 36,
        borderRadius: 2,
        backgroundColor: '#C8CACC'
      }}
      defaultOverlayOpacity={0.3}
      onClose={() => {
        if (closeDrawer) {
          closeDrawer()
        }
      }}
      isModal={!isWeb}
    >
      {children}
    </ActionSheet>
  )
}
